import React from 'react'
import makeStyles from '@material-ui/core/styles/makeStyles'

export default function CircleArrowBackIcon(props) {
    const { style, color, onClick } = props;
    const classes = useStyles({color, ...props})()

    return(
        <svg onClick={onClick} className={classes.container}  style={style} width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M10.5 21C4.7103 21 4.11788e-07 16.2897 9.17939e-07 10.5C1.42409e-06 4.7103 4.7103 -1.42409e-06 10.5 -9.17939e-07C16.2897 -4.11788e-07 21 4.7103 21 10.5C21 16.2897 16.2897 21 10.5 21ZM10.5 19.425C15.4214 19.425 19.425 15.4213 19.425 10.5C19.425 5.57865 15.4214 1.575 10.5 1.575C5.57865 1.575 1.575 5.57865 1.575 10.5C1.575 15.4213 5.57865 19.425 10.5 19.425ZM11.458 14.7024L7.79772 11.0579C7.64967 10.9098 7.56672 10.7093 7.56672 10.5003C7.56672 10.2903 7.64967 10.0898 7.79772 9.94171L11.458 6.29821C11.6113 6.14491 11.8129 6.06826 12.0135 6.06826C12.2151 6.06826 12.4177 6.14492 12.571 6.30032C12.8776 6.60902 12.8766 7.10671 12.5689 7.41332L9.46932 10.5003L12.5689 13.5863C12.8766 13.8929 12.8776 14.3916 12.571 14.7003C12.2644 15.0101 11.7667 15.008 11.458 14.7024Z" fill="#2196C0"/>
        </svg>
    )
}


const useStyles = ({color, ...props}) => makeStyles((theme) => ({
    container:{
        '& path': {
            fill: color ? color : theme.palette.primary.main,
            width: props.width,
         },
    }
}));